import * as Toggle from '@radix-ui/react-toggle-group'
import { useKestrel } from 'features/kestrelViewer'
import { DeleteAnnotationButton } from 'features/kestrelViewer/kestrelViewerMarkup/annotations/DeleteAnnotationButton'
import { SeverityCircle } from 'features/kestrelViewer/kestrelViewerMarkup/annotations/SeverityCircle'
import { ToggleAnnotationVisibilityButton } from 'features/kestrelViewer/kestrelViewerMarkup/annotations/ToggleAnnotationVisibilityButton'
import { ZoomToAnnotationButton } from 'features/kestrelViewer/kestrelViewerMarkup/annotations/ZoomToAnnotationButton'
import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'
import { KVAnnotation } from 'types'

const StyledAnnotationEntry = styled(Toggle.Item)<{ $selected: boolean }>`
  all: unset;
  cursor: ${({ $selected }) => ($selected ? 'auto' : 'pointer')} !important;
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.forecast.background4 : ''} !important;
  position: relative;
  padding: 4px;

  &:hover {
    opacity: ${({ $selected }) => ($selected ? 0.8 : 1)} !important;
    background-color: ${({ theme, $selected }) =>
      $selected
        ? theme.forecast.background4
        : theme.forecast.background3} !important;
  }
`

const PrimaryLineContainer = styled.div<{ $visible: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  color: ${({ $visible }) => ($visible ? 'white' : 'gray')};
  overflow: hidden;
`

const LeftSideInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: calc(100% - 80px);
  overflow: hidden;
`

const AnnotationLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  position: absolute;
  right: 0;
`

export const AnnotationEntry: FC<{
  annotation: KVAnnotation
  selectedMarkupId: string | undefined
}> = ({ annotation, selectedMarkupId }) => {
  const isSelected = annotation.id === selectedMarkupId
  const [isHovered, setIsHovered] = useState(false)
  const { setPopupMenuStartPosition, setSelectedMarkup } = useKestrel()
  return (
    <StyledAnnotationEntry
      value={annotation.id}
      $selected={isSelected}
      onClick={() => {
        if (setPopupMenuStartPosition) {
          // Position popup in top left of screen
          setPopupMenuStartPosition(new Vector2(10, 20))
        }
        setSelectedMarkup(
          selectedMarkupId === annotation.id ? undefined : annotation
        )
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <PrimaryLineContainer $visible={annotation.visible}>
        <LeftSideInfo>
          <SeverityCircle annotation={annotation} />
          <AnnotationLabel>{annotation.label}</AnnotationLabel>
        </LeftSideInfo>
        {!isHovered && annotation.type}
        {isHovered && (
          <ActionsContainer>
            <ZoomToAnnotationButton annotationId={annotation.id} />
            <ToggleAnnotationVisibilityButton annotation={annotation} />
            <DeleteAnnotationButton annotationId={annotation.id} />
          </ActionsContainer>
        )}
      </PrimaryLineContainer>
      {isSelected && (
        <div style={{ color: 'lightgray', fontStyle: 'italic' }}>
          {annotation.notes}
        </div>
      )}
    </StyledAnnotationEntry>
  )
}
